import { ThemeProvider } from '@mui/material';
import './App.css';
import Navigation from './navigation';
import theme from './theme';

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Navigation />
      </ThemeProvider>
    </div>
  );
}

export default App;
